// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"hF-z","smallCardRow":"iF-z","largeCardRow":"jF-z","productSearchRow":"kF-z","curatedRow":"lF-z"};